module.exports = __webpack_public_path__ + "static/media/Hedge-Trimming.a3b74f9a.jpg";